import React from 'react';
import { PrimaryButton } from '../Buttons/Button';

/**
 * Primary and "leave" buttons shared by every reauthentication and idle modal. Without `onSubmit` the
 * primary button submits the form it sits in; with it, it is a plain button.
 * @param {string} submitLabel - Already translated text of the primary button.
 * @param {string} leaveLabel - Already translated text of the leave button.
 * @param {boolean} [canSubmit] - Whether the primary button is enabled.
 * @param {function} [onSubmit] - Click handler for the primary button when it is not inside a form.
 * @param {function} onLeave - Click handler of the leave button.
 * @param {string} submitTestId - Test id of the primary button.
 * @param {string} [leaveTestId] - Test id of the leave button.
 * @author armandoricosandoval -ai-
 */
const ReauthActions = ({
  submitLabel,
  leaveLabel,
  canSubmit = false,
  onSubmit,
  onLeave,
  submitTestId,
  leaveTestId = 'reauth-leave-button'
}) => (
  <div className="te-reauth-actions">
    <PrimaryButton type={onSubmit ? 'button' : 'submit'} onClick={onSubmit} disabled={!canSubmit} data-testid={submitTestId}>
      {submitLabel}
    </PrimaryButton>
    <button type="button" className="te-reauth-leave" onClick={onLeave} data-testid={leaveTestId}>
      {leaveLabel}
    </button>
  </div>
);

export default ReauthActions;
